import { atom } from "jotai";
import { disputeFilterGroups } from "./predicate";
import { DisputeFilterAtom } from "./type";
const disputeFilters: DisputeFilterAtom = {
  filterGroup: disputeFilterGroups,
  filterValues: {},
  activeFilterKeys: [
    "from_amount",
    "to_amount",
    "dispute_type_ids",
    "date_range",
    "from_date",
    "to_date",
  ],
  sorting: {
    sort_col: "ID",
    order: "DESC",
  },
};

export const disputeFiltersAtom = atom(disputeFilters);
